<template>
    <div class="d-inline-block position-relative text-left">
        <div class="d-flex flex-row">
            <span v-if="label">{{ label }}</span>
            <div :class="{
            'ml-2': append,
            'mr-2': prepend
        }">
                <i class="fas cursor-pointer"
                   :class="{
                    'text-muted': muted && !expanded,
                    'fa-question-circle': !expanded,
                    'fa-info-circle text-info': expanded,
                }"
                   @click="expanded = !expanded"
                />
                <Transition name="bounce">
                    <div
                        class="position-absolute p-8 shadow-sm bg-light-info text-info cursor-pointer"
                        style="min-width: 280px; max-width: 320px; z-index: 1000;"
                        v-show="expanded"
                        @click="expanded = false"
                    >
                        <div v-if="titleText" class="font-weight-boldest text-uppercase text-info mb-1">
                            {{ titleText }}
                        </div>
                        <div class="font-weight-light text-dark">
                            <slot/>
                        </div>
                        <div class="font-weight-lighter text-dark opacity-50 font-size-sm text-uppercase mt-3">
                            {{ __('actions.click_to_close') }}
                        </div>
                    </div>
                </Transition>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        append: Boolean,
        prepend: Boolean,
        muted: Boolean,
        title: String,
        label: String,
    },

    data() {
        return {
            expanded: false
        }
    },

    computed: {
        titleText() {
            return this.label || this.title;
        }
    }
}
</script>

<style scoped>
.bounce-enter-active {
    animation: bounce-in 0.28s;
}

.bounce-leave-active {
    transition: all 0.36s ease-out;
}

.bounce-leave-to {
    transform: translateX(20px);
    opacity: 0;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    40% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}
</style>
